import { useState } from "react"
import { EcommerceIntegration } from "@/types/ecommerce"
import { getEcommerceIntegrations } from "@/api/ecommerce"

interface IUseEcommerce {
  isLoading: boolean
  ecommerceIntegrations: EcommerceIntegration[]
  fetchEcommerceIntegrations: () => Promise<void>
  setEcommerceIntegrations: (ecommerceIntegrations: EcommerceIntegration[]) => void
}

export const useEcommerce = (): IUseEcommerce => {
  const [ecommerceIntegrations, setEcommerceIntegrations] = useState<EcommerceIntegration[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const fetchEcommerceIntegrations = async () => {
    try {
      setIsLoading(true)
      const { data } = await getEcommerceIntegrations()
      setEcommerceIntegrations(data)
    } catch (error) {
      console.log(error)
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    ecommerceIntegrations,
    fetchEcommerceIntegrations,
    setEcommerceIntegrations,
  }
}
